import React, { memo, useEffect, useRef, useState } from 'react';
import { Card, List, Popover, Typography } from "antd";
import IntlMessages from "../../../util/IntlMessages";
import OutlineButton from "../../../components/OutlineButton";

import PcOn from "../../../assets/svg/PcOn";
import PcOff from "../../../assets/svg/PcOff";
import ArrowRight from 'src/assets/svg/ArrowRight';

import "./CardItem.css";
import StyledTooltip from 'src/components/StyledTooltip';
import VlinkLive from "../../../assets/svg/VlinkLive";
import {useIntl} from "react-intl";
import {getConstantLayoutAll} from "../../../util/common";

const {Text} = Typography;

export const CardItem = ({ data, onClick, showBtn=true }) => {
  const ellipsisRef = useRef();
  const intl = useIntl();

  const [showTooltip, setShowTooltip] = useState(false);

  const ConnectButtonComponent = memo(({ agent, style, disabled }) => (
    <div style={{...style}}>
      <OutlineButton
        // disabled={disabled}
        label={<IntlMessages id="vlink.common.shortConnect" />}
        onClick={() => {
          onClick && onClick(agent)
        }}
      />
    </div>
  ))

  const AgentStatusComponent = memo(({ agent }) => (
    <div style={{
      padding: 8, display: "flex", alignItems: "center"
    }}>
      {agent.status === 'pcOn' ? <PcOn /> : agent.status === 'live' ? <VlinkLive /> : <PcOff />}
    </div>
  ))

  const ArrowRightComponent = memo(() => (
    <div style={{
      display: "inline-flex", alignItems: "center"
    }}>
      <ArrowRight />
    </div>))

  const ellipsisContainerStyle = {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    lineHeight: "47px",
    position: "relative",
    width: "unset",
    display: "flex",
    alignItems: "center",
    minWidth: 0, // 필수!
    // width: "100%"
  };

  const handleBodyClick = () => {
    if (showBtn) {
      return
    }
    else {
      onClick(data);
    }
  }

  useEffect(() =>{
    // console.log("ellipsisRef check", data)
    // console.log(" ellipsisRef.scrollWidth , ellipsisRef.clientWidth", ellipsisRef.current?.scrollWidth , ellipsisRef.current?.clientWidth)
    if (ellipsisRef.current) {
      if (ellipsisRef.current.scrollWidth > ellipsisRef.current?.clientWidth ) {
        setShowTooltip(true)
      }
      else {
        setShowTooltip(false)
      }
    }
  }, [ellipsisRef, data])

  const tabToName = (tabName) => tabName === getConstantLayoutAll() ? intl.formatMessage({ id: `home.all` }) : tabName

  return <div style={{ display: "flex", width: "100%", alignItems: "center" }}>
    <div style={{ position: "relative", flex: 1, maxWidth: data.status && showBtn? "calc(100% - 65px)": "100%", height: 47, display: "flex", cursor: showBtn? "": "pointer" }}
      onClick={handleBodyClick}
    >
      <AgentStatusComponent agent={data} />
      <StyledTooltip content={showTooltip? (data.group_name? (tabToName(data.group_name) + " > "): "") + data.name + " > " + data.product : ""} placement="bottom" trigger="hover" >
        <div style={{ overflow: "hidden", width: "100%", paddingRight: 10 }}>
          <div style={ellipsisContainerStyle} ref={ellipsisRef}>
            <Text ellipsis>
              {tabToName(data.group_name)}
            </Text>
            {data.group_name && <ArrowRightComponent />}
            <Text ellipsis>
              {data.name}
            </Text>
            <ArrowRightComponent />
            <span style={{ whiteSpace: "nowrap", flexShrink: 0 }}>
              {data.product}
            </span>
          </div>
        </div>
      </StyledTooltip>
    </div>
    {data.status !== "pcOff" && showBtn && <ConnectButtonComponent style={{width: "60px"}} agent={data}/>}
  </div>
}
